import { PowerBIEmbed } from 'powerbi-client-react'
import { models } from 'powerbi-client';
import { useEffect, useState } from 'react'
import apiFetch from 'apiFetch'
import { useMsal } from '@azure/msal-react'
import { getAuthHeader, REACT_APP_PS_PORTAL_API_URI } from 'authHelper'

const PbiReport = () => {
  const { instance, accounts } = useMsal()
  const [defaultReportConfig, setDefaultReportConfig] = useState(null)
  const [loading, setLoading] = useState(true)

  async function getReports() {
    try {
      const authHeader = await getAuthHeader(instance, accounts)
      const embedConfigResult = await apiFetch.get(`${REACT_APP_PS_PORTAL_API_URI}/telemetry/pbitoken`, {
        headers: authHeader
      })
      const embedConfig = embedConfigResult.data

      setDefaultReportConfig({
        type: 'report',
        id: embedConfig.reportId,
        embedUrl: embedConfig.embedUrl,
        accessToken: embedConfig.embedToken.token,
        tokenType: models.TokenType.Embed
      })
    }
    catch {
      setDefaultReportConfig(null)
    }
    finally {
      setLoading(false)
    }
  }

  // https://stackoverflow.com/questions/60618844/react-hooks-useeffect-is-called-twice-even-if-an-empty-array-is-used-as-an-ar
  // React.Strict mode is on
  useEffect(() => {
    getReports()
  }, [])

  return (
    <>
    { !loading && 
    <div className="pbiReportWrapper">
      {defaultReportConfig &&
      <PowerBIEmbed
        embedConfig={defaultReportConfig}
      />
      }
    </div>
    }
    </>
  )
}

export default PbiReport
